// Retry transient failures only. Never turn a disabled site or denied request
// into permission to collect. Each attempt is bounded, including a stalled fetch.
export async function requestWithRetry(url: string, options: RequestInit): Promise<Response> {
  for (let attempt = 0; ; attempt += 1) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    let retry = false;
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      retry = response.status === 408 || response.status === 429 || response.status >= 500;
      if (!retry || attempt === 2) return response;
    } catch (error) {
      if (attempt === 2) throw error;
      retry = true;
    } finally {
      clearTimeout(timeout);
    }
    if (retry) await new Promise<void>((resolve) => setTimeout(resolve, 1000 * (attempt + 1)));
  }
}
